const contractAddress = "0xCE3178E3A95c905351616D42c18d0CCac2aC87A1"; //testnet only
export default contractAddress; 